import { restClient } from '@/Core'

import { DISK_ADMIN_API, adminPath } from './diskAdminApi'

import type { DiskOffboardingRow } from '../Contracts/DiskAdmin'

/** Справи звільнення, що чекають рішення: `GET /services/disk/admin/offboardings?status=pending`. */
export const LoadDiskOffboardingsTask = async (limit: number): Promise<{ items: DiskOffboardingRow[]; total: number }> => {
    const response = (await restClient.get(
        `${DISK_ADMIN_API}/offboardings`,
        { searchParams: { status: 'pending', limit } },
        { forceRefresh: true }
    )) as unknown as { items?: DiskOffboardingRow[]; total?: number } | null

    return { items: response?.items ?? [], total: response?.total ?? 0 }
}

/** Одна справа (`GET …/offboardings/{uuid}`) — щоб із посилання сповіщення знайти її простір. */
export const LoadDiskOffboardingTask = async (uuid: string): Promise<DiskOffboardingRow> =>
    (await restClient.get(adminPath('offboardings', uuid), {}, { forceRefresh: true })) as unknown as DiskOffboardingRow
